<template>
  <div class="wrapper d-flex justify-content-end min-vh-100">
    <EditSideBar
      :questionnaireOptions="partList"
      :questionnaireId="questionnaireId"
    />
    <div class="body">
      <CContainer fluid class="ps-4">
        <div class="inner-container">
          <div class="header">
            <h1>分類管理</h1>
          </div>
          <div class="type-wrapper mt-3 p-4">
            <div class="title-wrapper px-2 my-2">
              <input
                type="text"
                placeholder="問卷標題"
                class="title"
                v-model="questionnaireTitle"
                @blur="setTitle"
              />
            </div>
            <div class="d-flex flex-column w-100 col-12">
              <Draggable
                handle=".handle"
                @sort="sort"
                :list="questionnaireOptions"
                group="part"
                item-key="part_item_id"
                :clone="cloneList"
              >
                <template #item="{ element, index }">
                  <div
                    class="d-flex align-items-center justify-content-start col-8 my-3"
                  >
                    <el-switch
                      v-model="element.is_display"
                      :active-value="$defines.Part_Is_Display_Yes"
                      :inactive-value="$defines.Part_Is_Display_No"
                    />
                    <input
                      type="text"
                      class="mx-3 content rounded px-3 w-100"
                      placeholder="請填寫分類標題"
                      v-model="element.title"
                      @blur="element"
                    />
                    <div class="d-flex">
                      <img
                        style="cursor: pointer"
                        src="@/assets/icons/add.svg"
                        class="option-img"
                        alt="add"
                        v-c-popover="{
                          content: '新增',
                          placement: 'top',
                          trigger: 'hover',
                        }"
                        @click="addOption(index)"
                      />
                      <img
                        style="cursor: pointer"
                        src="@/assets/icons/minus.svg"
                        class="option-img"
                        alt="minus"
                        v-c-popover="{
                          content: '刪除',
                          placement: 'top',
                          trigger: 'hover',
                        }"
                        @click="deleteOption(index)"
                      />
                      <img
                        style="cursor: pointer"
                        v-if="element.action != $defines.SAVE_ACTION_CREATE"
                        src="@/assets/icons/list-copy.svg"
                        class="option-img"
                        alt="copy"
                        v-c-popover="{
                          content: '複製',
                          placement: 'top',
                          trigger: 'hover',
                        }"
                        @click="copyQuestionnairePart(index)"
                      />
                      <img
                        style="cursor: pointer"
                        src="@/assets/icons/list-sort.svg"
                        class="option-img handle"
                        alt=""
                        v-c-popover="{
                          content: '拖曳',
                          placement: 'top',
                          trigger: 'hover',
                        }"
                      />
                    </div>
                  </div>
                </template>
              </Draggable>
              <div class="d-flex justify-content-end">
                <CButton
                  v-if="questionnaireId"
                  @click="editClassification"
                  color="primary"
                  >儲存並編輯問卷
                </CButton>
                <CButton v-else @click="createClassification" color="primary"
                  >儲存並編輯問卷
                </CButton>
              </div>
            </div>
          </div>
        </div>
      </CContainer>
    </div>
    <MsgBox
      :show="showMsgBox"
      :errorCode="errorCode"
      :errorMsg="errorMsg"
      @close="showMsgBox = false"
    />
  </div>
</template>
<script>
import EditSideBar from '@/components/EditSideBar.vue'
import MsgBox from '@/components/MsgBox.vue'
import useQuestionnaire from '@/composables/useQuestionnaire'
import { onBeforeRouteLeave, useRoute } from 'vue-router'
import { manualToggleLoading } from '@/plugins/LoadingSpinner'
import { ref } from '@vue/reactivity'
import router from '@/router'
import MessageBox from '@/plugins/MessageBox'
import { computed } from '@vue/runtime-core'
import Draggable from 'vuedraggable'
import {
  SAVE_ACTION_CREATE,
  SAVE_ACTION_DELETE,
  SAVE_ACTION_UPDATE,
  SAVE_ACTION_COPY,
  Part_Is_Display_Yes,
} from '@/defines'

export default {
  components: {
    EditSideBar,
    MsgBox,
    Draggable,
  },

  setup() {
    const route = useRoute()
    const {
      // questionnairePartCopy,
      createQuestionnaire,
      getQuestionnaire,
      editPartQuestionnaire,
    } = useQuestionnaire()
    const questionnaireId = ref('')
    const questionnaireTitle = ref('')
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const originListStr = ref('[]')
    const partList = ref([])
    const deletePartList = ref([])
    const reloading = ref(false)
    const setTitle = () => {
      localStorage.setItem('title', questionnaireTitle.value)
    }
    const questionnaireOptions = ref([
      {
        title: '',
        action: SAVE_ACTION_CREATE,
        is_display: Part_Is_Display_Yes
      },
    ])

    const copyQuestionnairePart = async (index) => {
      const partInfo = questionnaireOptions.value[index]
      if (partInfo.action == SAVE_ACTION_CREATE) {
        return
      }
      if (!confirm('是否確定複製分類')) {
        return
      }
      const data = {
        id: questionnaireOptions.value[index].id,
        title: questionnaireOptions.value[index].title + ' 複製',
        is_display: questionnaireOptions.value[index].is_display,
        action: SAVE_ACTION_COPY,
      }
      questionnaireOptions.value.splice(index + 1, 0, data)

      // const res = await questionnairePartCopy({
      //   questionnaire_id: questionnaireId.value,
      //   part_id: partInfo.id,
      // })
      // if (res.error) {
      //   showMsgBox.value = true
      //   errorMsg.value = res.msg
      //   errorCode.value = res.error
      //   return
      // }
      // showMsgBox.value = true
      // errorMsg.value = '複製成功'
      // setTimeout(() => {
      //   reloading.value = true
      //   location.reload()
      // }, 500)
    }

    const addOption = (index) => {
      const res = {
        title: '',
        action: SAVE_ACTION_CREATE,
        is_display: Part_Is_Display_Yes
      }
      questionnaireOptions.value.splice(index + 1, 0, res)
    }
    const deleteOption = (index) => {
      if (questionnaireOptions.value[index].action != SAVE_ACTION_CREATE) {
        if (!confirm('是否確認刪除')) {
          return false
        }
      }
      if (questionnaireOptions.value.length > 1) {
        const deleteItems = questionnaireOptions.value.splice(index, 1)
        deleteItems.forEach((deleteItem) => {
          if (deleteItem.action != SAVE_ACTION_CREATE) {
            deleteItem.action = SAVE_ACTION_DELETE
            deletePartList.value.push(deleteItem)
          }
        })
      }
    }

    const getQue = async () => {
      if (!route.params.id) return
      manualToggleLoading(true)
      const res = await getQuestionnaire({ id: +route.params.id })
      if (res.error) {
        manualToggleLoading(false)
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        manualToggleLoading(false)

        const questionnaire = res.ret.questionnaire
        questionnaire.parts = questionnaire.parts.map((item) => {
          return { ...item, action: SAVE_ACTION_UPDATE }
        })
        partList.value = JSON.parse(JSON.stringify(questionnaire?.parts))
        originListStr.value = JSON.stringify(questionnaire?.parts)
        questionnaireId.value = questionnaire?.id
        questionnaireTitle.value = questionnaire?.title
        questionnaireOptions.value = questionnaire?.parts || [
          {
            title: '',
            action: SAVE_ACTION_CREATE,
            is_display: Part_Is_Display_Yes
          },
        ]
      }
    }
    getQue()
    const cloneList = (e) => {
      const item = JSON.parse(JSON.stringify(e))
      item.time = new Date().getTime()
      return item
    }
    const hasEdited = computed(() => {
      const sortedOrigin = JSON.parse(originListStr.value).map((obj) => {
        return Object.fromEntries(Object.entries(obj).sort())
      })

      const sortedCurrent = JSON.parse(
        JSON.stringify(questionnaireOptions.value),
      ).map((obj) => {
        return Object.fromEntries(Object.entries(obj).sort())
      })

      return JSON.stringify(sortedOrigin) !== JSON.stringify(sortedCurrent)
    })
    // const beforeUnloadListener = (event) => {
    //   if (hasEdited.value) {
    //     if (reloading.value) return false
    //     event.preventDefault()
    //     return (event.returnValue = 'Are you sure you want to exit?')
    //   }
    // }
    // window.addEventListener('beforeunload', beforeUnloadListener, {
    //   capture: true,
    // })

    // onBeforeUnmount(() => {
    //   window.removeEventListener('beforeunload', beforeUnloadListener, {
    //     capture: true,
    //   })
    // })
    const createClassification = async () => {
      questionnaireOptions.value = questionnaireOptions.value.filter((e) => {
        return e.title !== ''
      })
      const res = await createQuestionnaire({
        title: questionnaireTitle.value,
        parts: [...questionnaireOptions.value, ...deletePartList.value],
      })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
        // questionnaireOptions.value = [
        //   {
        //     title: '',
        //     action: SAVE_ACTION_CREATE,
        //   },
        // ]
      } else {
        showMsgBox.value = true
        errorMsg.value = '創建成功'
        setTitle()
        originListStr.value = JSON.stringify(questionnaireOptions.value)
        router.push(`/edit-classification/${res.ret.questionnaire_id}`)
        setTimeout(() => {
          location.reload()
          getQue()
        }, 500)
      }
    }
    const editClassification = async () => {
      questionnaireOptions.value = questionnaireOptions.value.filter((e) => {
        return e.title !== ''
      })
      const res = await editPartQuestionnaire({
        id: questionnaireId.value,
        title: questionnaireTitle.value,
        parts: [...questionnaireOptions.value, ...deletePartList.value],
      })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        // showMsgBox.value = true
        // errorMsg.value = '修改成功'
        MessageBox({
              message: '修改成功',
              showCancelButton: false,
              confirmButtonText: '修改中...',
            })
            reloading.value = true
            location.reload()
      }
    }
    onBeforeRouteLeave(async () => {
      if (hasEdited.value) {
        let flag = null
        MessageBox({
          message: '此分類尚未儲存，請先儲存再進行動作避免資料遺失。',
          cancelButtonText: '不保存離開此頁',
          confirmButtonText: '繼續編輯',
          cancelBtnColor: 'secondary',
          confirmBtnColor: 'primary',
          onConfirm: () => {
            flag = true
          },
          onCancel: () => {
            flag = false
          },
        })
        let p = new Promise((resolve) => {
          const timer = setInterval(() => {
            if (flag !== null) {
              clearInterval(timer)
              resolve(flag)
            }
          }, 30)
        })
        const saveConfirm = await p
        if (saveConfirm) {
          flag = null
          return false
        } else {
          return true
        }
      }
    })
    return {
      questionnaireId,
      questionnaireOptions,
      addOption,
      deleteOption,
      questionnaireTitle,
      showMsgBox,
      errorMsg,
      errorCode,
      createClassification,
      editClassification,
      setTitle,
      partList,
      hasEdited,
      cloneList,
      copyQuestionnairePart,
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 40px 0px;
}

.inner-container {
  margin: 0 auto;
  max-width: 1136px;
}

.body {
  width: calc(100vw - 255px);
}

h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
}

.type-wrapper {
  background: #ffffff;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
}

.title-wrapper {
  width: 100%;
  border: 0;
  border-bottom: 1px solid #9ca0a8;
  outline: none;
}

.title {
  width: 100%;
  border: 0;
  outline: none;
}

.option-img {
  width: 15px;
  margin: 0 10px;
}

.content {
  background-color: #fff !important;
  border: 1px solid #9ca0a8;
  border-radius: 3px;
  width: 100%;
}
</style>
